export default __webpack_public_path__ + "static/media/9.3af22788.jpg";